import { connect } from 'react-redux';
export class ConnectedComponent {
    mapToProps(mapStateToProps, mapDispatchToProps) {
        return {
            propsGeneric: null,
            connect: (component) => connect(mapStateToProps, mapDispatchToProps)(component)
        };
    }
}
